/**
 * User-facing product identity. The product name is expected to change —
 * rename by editing THIS file and lib/fireside/product.rb together
 * (spec/product_spec.rb fails when they drift). LEGACY_PRODUCT_NAME brands
 * the frozen steam-era surfaces under /steam and never changes.
 */
export const PRODUCT_NAME = 'GTG GC'
export const PRODUCT_LONG_NAME = 'Got To Go Golf Club'
/** Placeholder copy until the design pass. */
export const PRODUCT_TAGLINE = 'A virtual golf club for people who have got to go.'
export const LEGACY_PRODUCT_NAME = 'Fireside'
